module.exports = __webpack_public_path__ + "static/media/test2.b0a1ee96.jpeg";